module.exports = __webpack_public_path__ + "img/Portraitbild_OB_2018.20048230.jpg";